import { RadioProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

export default function Radio(theme: Theme) {
  const rootStyles = (ownerState: RadioProps) => {
    const smallSize = ownerState.size === 'small';
    const mediumSize = ownerState.size === 'medium';

    const defaultStyle = {
      padding: theme.spacing(1),
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
      },
    };

    const size = {
      ...(smallSize && {
        padding: theme.spacing(1.5),
        maxWidth: 12,
        maxHeight: 12,
      }),
      ...(mediumSize && {
        padding: theme.spacing(2),
        maxWidth: 16,
        maxHeight: 16,
      }),
    };

    return { ...defaultStyle, ...size };
  };
  return {
    MuiRadio: {
      defaultProps: {
        size: 'small',
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: RadioProps }) =>
          rootStyles(ownerState),
      },
    },
  };
}
